/**
 * @generated SignedSource<<46409085a5836e23f4778b39af2b5579>>
 * @relayHash 33fba0ed0a08172d8d53c1ca261d4e4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52c11db9242aa3ffd0d4d413cae396acd94a1b3f58735edd9ee74305ec36b93d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybooksPanelBodyQuery } from './PlaybooksPanelBodyQuery.graphql';

const node: PreloadableConcreteRequest<PlaybooksPanelBodyQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "52c11db9242aa3ffd0d4d413cae396acd94a1b3f58735edd9ee74305ec36b93d",
    "metadata": {},
    "name": "PlaybooksPanelBodyQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
